angular.module('BBPublicBooking').directive('bbMonthPickerListener', ($timeout) => {
        return {
            restrict: 'A',
            scope: true,
            link(scope, el, attrs) {
                $(window).resize(() =>
                    $timeout(() => scope.carouselIndex = 0)
                );

                return scope.$on('event_list_filter:changed', () =>
                    $timeout(() => scope.carouselIndex = 0)
                );
            }
        };
    }
);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/month-picker-listener/bb_month_picker_listener.directive.js